import { Spacing } from '@persona-id/design-tokens';
import styled from 'styled-components';

import {
  ScreenDimensions,
  TemplateStepPreview,
} from 'dashboard/apps/InquiryTemplateEditor/InquiryTemplateEditor/types';
import InquiryTemplateScreenPreview, {
  PREVIEW_WIDTH,
} from 'dashboard/apps/InquiryTemplateEditor/InquiryTemplateScreenPreview/InquiryTemplateScreenPreview';
import ReactSelect from 'dashboard/components/ReactSelect';
import { paragraphMixins } from 'design-system/mixins/text';
import { BASE } from 'design-system/variables/spacing';
import { FRAME_HEIGHT } from 'verify/components/Application/Frame';
import { ThemeAttributes } from 'verify/models/theme';

export const NEW_CONNECTOR_CARD_WIDTH = 350;
const SCREEN_PREVIEW_SCALE_FACTOR = 0.45;
export const PLACEHOLDER_TEXT = 'Select screen';

const Header = styled.div`
  ${paragraphMixins.lgBold}
  color: ${({ theme }) => theme.color.text.primary};
  margin-bottom: ${Spacing[2]};
`;

const Description = styled.div`
  ${paragraphMixins.md}
  color: ${({ theme }) => theme.color.text.secondary};
  margin-bottom: ${Spacing[4]};
`;

const Card = styled.div<{ isNewConnector: boolean }>`
  background-color: ${({ theme }) => theme.color.background.primary};
  padding: ${({ isNewConnector }) => (isNewConnector ? BASE * 3 : BASE * 1.5)}px;
`;

const SelectWrapper = styled.div`
  width: 100%;
`;

const StepPreviewWrapper = styled.div.attrs<{ screenDimensions?: ScreenDimensions }>((props) => ({
  style: {
    width: `${(props?.screenDimensions?.width ?? PREVIEW_WIDTH) * SCREEN_PREVIEW_SCALE_FACTOR}px`,
    height: `${(props?.screenDimensions?.height ?? FRAME_HEIGHT) * SCREEN_PREVIEW_SCALE_FACTOR}px`,
  },
}))<{ screenDimensions?: ScreenDimensions }>`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-left: auto;
  margin-right: auto;
  margin-top: ${Spacing[4]};

  transform: scale(${SCREEN_PREVIEW_SCALE_FACTOR * 100}%);
  & > * {
    cursor: auto;
    user-select: none;
  }
`;

interface StepOption {
  name: string;
  title: string;
}

interface EditConnectorDialogProps {
  theme?: ThemeAttributes;
  stepOptions: StepOption[];
  selectedStep: TemplateStepPreview | null;
  screenDimensions: ScreenDimensions;
  handleStepSelect: (name: string) => void;
}

const EditConnectorDialog = ({
  theme,
  stepOptions,
  selectedStep,
  screenDimensions,
  handleStepSelect,
}: EditConnectorDialogProps) => {
  return (
    <Card isNewConnector={selectedStep == null}>
      <Header>Connector</Header>
      <Description>The connector routes users to an existing screen in the flow.</Description>
      <SelectWrapper data-test='edit-connector-dialog__select-step'>
        <ReactSelect
          id='edit-connector-dialog__select-step'
          aria-label='Select connector step'
          placeholder={PLACEHOLDER_TEXT}
          value={selectedStep?.name}
          options={stepOptions.map(({ name, title }) => ({ label: title, value: name }))}
          onChange={handleStepSelect}
          autoFocus
        />
      </SelectWrapper>
      {selectedStep && (
        <StepPreviewWrapper screenDimensions={screenDimensions}>
          <InquiryTemplateScreenPreview
            theme={theme}
            page={selectedStep.page}
            step={selectedStep.stepPreview}
            screenDimensions={screenDimensions}
          />
        </StepPreviewWrapper>
      )}
    </Card>
  );
};

export default EditConnectorDialog;
